import React from 'react';

import { useAccountState } from './AccountContext';

const AccountEmail = () => {
  const state = useAccountState();

  if (state?.loading) {
    return (
      <>
        <p>Loading...</p>
      </>
    );
  }

  return (
    <>
      <p>{state?.account?.primaryEmail}</p>
      <p>The email address associated with your Isibute account.</p>
    </>
  );
};

export default AccountEmail;